import { render, staticRenderFns } from "./AudienceAvailabilityListModal.vue?vue&type=template&id=5385a95a&"
import script from "./AudienceAvailabilityListModal.vue?vue&type=script&lang=js&"
export * from "./AudienceAvailabilityListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports